import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import PortfolioPage from './pages/PortfolioPage';
import AiPortfolioPage from './pages/AiPortfolioPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/ui-portfolio" element={<PortfolioPage />} />
      <Route path="/ai-portfolio" element={<AiPortfolioPage />} />
    </Routes>
  );
}

export default App;
